/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TaskEvaluationSubjectInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class TaskEvaluationSubjectApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'TaskEvaluationSubjects');
  }

  setTaskEvaluationSubjectForTask(
    taskId: number,
    taskEvaluationSubjects: TaskEvaluationSubjectInterface[]
  ): Observable<any> {
    return this.post(`task/${taskId}`, undefined, {
      taskEvaluationSubject: taskEvaluationSubjects,
    });
  }
}
